import React, { useState } from 'react';
import { Button, Space, Row, Col, message } from 'antd';
import QR_HDFC from "./PrintingAssets/HDFC_QR.svg";
import QR_AXIS from "./PrintingAssets/AXIS_QR.svg";
import QR_ZINIZ from "./PrintingAssets/ZINIZ_QR.svg";
import './docPrinting.css'; // Make sure this path is correct

const upiList = [
  {
    upi: 'ZINIZ@KOTAK',
    label: 'KOTAK',
    qrCode: QR_ZINIZ,
    colorClass: 'upi-box-kotak',
  },
  {
    upi: '9776065643@HDFCBANK',
    label: 'HDFC',
    qrCode: QR_HDFC,
    colorClass: 'upi-box-hdfc',
  },
  {
    upi: 'swetlina.satpathy@okaxis',
    label: 'AXIS',
    qrCode: QR_AXIS,
    colorClass: 'upi-box-axis',
  },
];

const PaymentOptions = () => {
  const [visibleQr, setVisibleQr] = useState(null);

  const handleCopy = async (upi) => {
    try {
      await navigator.clipboard.writeText(upi);
      message.success(`Copied: ${upi}`);
    } catch (err) {
      message.error('Failed to copy');
    }
  };

  return (
    <Row gutter={24} className="upi-row">
      {upiList.map(({ upi, label, qrCode, colorClass }) => (
        <Col key={upi} xs={24} sm={24} md={8}>
          <div className={`upi-box ${colorClass}`}>
            <div className="upi-label">{label}</div>
            <div className="upi-text">{upi}</div>

            <Space wrap>
              <Button size="small" type="primary" onClick={() => handleCopy(upi)}>
                Copy
              </Button>
              <Button
                size="small"
                onClick={() => setVisibleQr(prev => (prev === upi ? null : upi))}
              >
                {visibleQr === upi ? 'Hide QR' : 'Show QR'}
              </Button>
            </Space>

            {visibleQr === upi && (
              <div className="upi-qr-wrapper">
                <img
                  src={qrCode}
                  alt={`QR for ${upi}`}
                  className="upi-qr"
                />
              </div>
            )}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default PaymentOptions;